const dashaboard = {
  path: "/",
  redirect: "/dashboard",
  component: () => import("@/layout/Layout.vue"),
  children: [
    {
      path: "/dashboard",
      name: "dashboard",
      meta: {
        requireAuth: false,
      },
      component: () => import("@/views/Dashboard.vue"),
    },
  ],
};

export { dashaboard };
